import React from "react";

/**
 * One sprite out of a Christmas atlas (see atlas.js), drawn as a background so
 * a page can place dozens of them from a single image request.
 *
 * `scale` is relative to the atlas pixels. Whole-number scales stay pixel-sharp;
 * anything else is drawn smooth, because nearest-neighbour at 0.7× drops whole
 * rows of the art and the shapes go ragged.
 */
export default function Sprite({ atlas, name, scale, className, style, ...rest }) {
  var s = scale || 1;
  var r = atlas.rects[name];
  var crisp = s >= 1 && Math.round(s) === s;
  return (
    <span
      aria-hidden="true"
      className={"xm-sprite" + (crisp ? " xm-crisp" : "") + (className ? " " + className : "")}
      style={Object.assign(
        {
          width: r[2] * s,
          height: r[3] * s,
          backgroundImage: "url(" + atlas.src + ")",
          backgroundPosition: -r[0] * s + "px " + -r[1] * s + "px",
          backgroundSize: atlas.width * s + "px " + atlas.height * s + "px",
        },
        style
      )}
      {...rest}
    />
  );
}
